import React from 'react';
import PrimePageTranslationsPageProvider from './PrimePageTranslationsPageProvider';
import { PortalAsync } from '@edreamsodigeo/frontend-core';
import { DiscoverMoreLinkPrimePageDP } from '@edreamsodigeo/frontend-prime';
const PrimePage = () => /*#__PURE__*/React.createElement(PrimePageTranslationsPageProvider, null, /*#__PURE__*/React.createElement(PortalAsync, {
  elementId: "more-info-prime-page",
  parentId: "ancillaries-module",
  Component: DiscoverMoreLinkPrimePageDP
}));
export default PrimePage;